import type ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import { createContext } from 'react';

const SectionContentGroupContext = createContext<ContentGroupType>(
  null as unknown as ContentGroupType,
);

export default SectionContentGroupContext;
